import { RootState } from '../../reducers'

export const devToolsSliceSelector = (state: RootState) => state.devTools

export const forcedBotFeaturesSelector = (state: RootState) =>
  devToolsSliceSelector(state).forcedBotFeatures

export const devToolsPositionSelector = (state: RootState) => devToolsSliceSelector(state).position

export const areDevToolsOpenSelector = (state: RootState) => devToolsSliceSelector(state).isOpen
